import FormattedMessage from 'I18n/components/FormattedMessage';
import { Flex } from 'foundations-components/components/Flex';
import { View } from 'foundations-components/components/View';
import { SignupButton } from 'purchase-motions-components/components/PurchaseMotions/SignupButton/SignupButton';
import { TRACKING_SOURCES, trackSignupButtonClick } from '../../../utils/tracking';
import { PublicPurchaseMotionCTAWrapper } from '../../PublicPurchaseMotionCTAWrapper';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const PublicMerchCardCTAs = ({
  card,
  currencyCode,
  paymentTerm,
  commitmentTerm,
  motions,
  screen,
  secondaryCTA,
  layout = 'column'
}) => {
  const isFree = card.productLevel === 'FREE';
  if (motions.length === 0 && !isFree) return null;
  return /*#__PURE__*/_jsxs(Flex, {
    flexDirection: layout,
    gap: "200",
    inlineSize: "100%",
    children: [isFree && /*#__PURE__*/_jsx(View, {
      flex: layout === 'row' ? 1 : undefined,
      children: /*#__PURE__*/_jsx(SignupButton, {
        apiName: card.productApiName,
        trackingData: {
          app: 'pricing-pages',
          source: 'merch-card',
          screen,
          uniqueId: `merch-card-${card.productApiName}`
        },
        onClick: () => trackSignupButtonClick({
          trackingSource: TRACKING_SOURCES.MERCH_CARD,
          screen,
          productNames: [card.productApiName]
        }),
        uiButtonProps: {
          use: 'primary',
          block: true
        },
        "data-selenium-id": "free-signup-button",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "publicPricingPage.merchCard.cta.getStartedFree"
        })
      })
    }), motions.map((motion, index) => /*#__PURE__*/_jsx(View, {
      flex: layout === 'row' ? 1 : undefined,
      children: /*#__PURE__*/_jsx(PublicPurchaseMotionCTAWrapper, {
        purchaseMotion: motion,
        productApiName: card.productApiName,
        currencyCode: currencyCode,
        paymentTerm: paymentTerm,
        commitmentTerm: commitmentTerm,
        displayIndex: isFree ? index + 1 : index,
        trackingData: {
          app: 'pricing-pages',
          source: 'merch-card',
          screen,
          uniqueId: `merch-card-${card.productApiName}`
        }
      })
    }, motion)), secondaryCTA && /*#__PURE__*/_jsx("div", {
      children: secondaryCTA
    })]
  });
};